
import { TextField } from "@mui/material";
import { usePlacesWidget } from "react-google-autocomplete";
import { appConstants } from "utils/appConstants";


const Auto = (props) => {

  const { ref } = usePlacesWidget({
    apiKey: appConstants.googleAutoCommpleteKey,
    onPlaceSelected: props.onPlaceSelected,
    options: {
      types: ["address"],
      componentRestrictions: { country: "au" },

    },
  });
  const disableAutocomplete = () => {
    const inputElement = document.getElementById("inputField"); // Replace with the actual ID of your input element
    if (inputElement) {
      inputElement.setAttribute("autocomplete", "off");
    }
  };
  window.addEventListener("load", disableAutocomplete);
  return (

    <TextField

      inputRef={ref}
      inputProps={{
        maxLength: 100,
        className: "custom-fieldtext"
      }}
      helperText={props.helperText}
      error={props.error}

      autoComplete="off"
      disabled={props.disabled}
      className="GoogleInput"
      onChange={props.onChange}
      inputClassName="GoogleInput"

      id={"outlined-error"}
      value={props.value}
      placeholder={props.defaultValue}
      label="Street Address"
      InputLabelProps={{ shrink: true }}
      variant={props.variant === "standard" ? "standard" : "outlined"}
    />

  );
};


export default Auto;